import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { getProfessional } from "../api/getProfessional";
import { IProfessionalSchedulesAvailable } from "../api/getProfessionals";
import registerCheckout from "../api/registerCheckout";
import PageWrapper from "../components/common/PageWrapper";
import ProcedureSelector, { ProceduresType } from "../components/common/ProcedureSelector";
import ProfessionalProfile from "../components/common/ProfessionalProfile";
import FreeTimePicker from "../components/pickers/FreeTimePicker";

const Wrapper = styled.div`
	height: 100vh;
	display: flex;
	flex-direction: column;
`;

const ProfessionalProfileWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: flex-start;
	align-content: normal;
`;

const RescheduleScreen = () => {
	const { professionalId, scheduleId } = useParams<{ professionalId: string; scheduleId: string }>();
	const navigate = useNavigate();
	const [procedures, setProcedures] = useState<ProceduresType[]>();

	const getProfessionalProcedures = useCallback(async () => {
		if (!professionalId) return;

		const professionalResponse = await getProfessional(professionalId);
		setProcedures(professionalResponse.procedimentos);
	}, [professionalId]);

	const handleReschedule = async (availableShedule: IProfessionalSchedulesAvailable) => {
		const response = await registerCheckout(availableShedule.idHorario);
		if (response) {
			navigate(`/medicos/${professionalId}/checkout/${response.id}/reschedule/${scheduleId}?step=0`, { state: availableShedule });
		}
	};

	useEffect(() => {
		getProfessionalProcedures();
	}, [getProfessionalProcedures]);

	return (
		<PageWrapper>
			<Wrapper>
				<ProfessionalProfileWrapper>
					<ProfessionalProfile showMoreAboutButton={false} codProfessional={professionalId} />
				</ProfessionalProfileWrapper>

				{/* MULTIPROCEDIMENTO */}
				<ProcedureSelector procedures={procedures} disabled />

				{professionalId && <FreeTimePicker title="Escolha o novo horário:" handleClick={handleReschedule} codProfessional={professionalId} />}
			</Wrapper>
		</PageWrapper>
	);
};

export default RescheduleScreen;
